import { render, staticRenderFns } from "./WalletBody.vue?vue&type=template&id=2f686e83&"
import script from "./WalletBody.vue?vue&type=script&lang=js&"
export * from "./WalletBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports